import { render, staticRenderFns } from "./SimpleProductComplianceOverview.vue?vue&type=template&id=a06743b2&"
import script from "./SimpleProductComplianceOverview.vue?vue&type=script&lang=js&"
export * from "./SimpleProductComplianceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports